export const contactDeactivationModalTranslations = {
  welcomeStep: {
    title: 'cng-contact_deactivation_modal-welcome_step-title',
    description: 'cng-contact_deactivation_modal-welcome_step-description',
    buttons: {
      proceed: 'cng-contact_deactivation_modal-welcome_step-buttons-proceed',
      cancel: 'cng-contact_deactivation_modal-welcome_step-buttons-cancel',
    },
  },
  reassignRolesStep: {
    title: 'cng-contact_deactivation_modal-reassign_roles_step-title',
    description: 'cng-contact_deactivation_modal-reassign_roles_step-description',
    selectContact: 'cng-contact_deactivation_modal-reassign_roles_step-select_contact',
    eyeButtonTooltip: 'cng-contact_deactivation_modal-reassign_roles_step-eye_button_tooltip',
    buttons: {
      proceed: 'cng-contact_deactivation_modal-reassign_roles_step-buttons-proceed',
      cancel: 'cng-contact_deactivation_modal-reassign_roles_step-buttons-cancel',
    },
  },
  reassignFlagsStep: {
    title: 'cng-contact_deactivation_modal-reassign_flags_step-title',
    description: 'cng-contact_deactivation_modal-reassign_flags_step-description',
    buttons: {
      proceed: 'cng-contact_deactivation_modal-reassign_flags_step-buttons-proceed',
      cancel: 'cng-contact_deactivation_modal-reassign_flags_step-buttons-cancel',
    },
  },
  backupStep: {
    title: 'cng-contact_deactivation_modal-backup_step-title',
    description: 'cng-contact_deactivation_modal-backup_step-description',
    content: 'cng-contact_deactivation_modal-backup_step-content',
    newContact: 'cng-contact_deactivation_modal-backup_step-new_contact',
    partnerNotFound: 'cng-contact_deactivation_modal-backup_step-partner_not_found',
    buttons: {
      proceed: 'cng-contact_deactivation_modal-backup_step-buttons-proceed',
      cancel: 'cng-contact_deactivation_modal-backup_step-buttons-cancel',
      create: 'cng-contact_deactivation_modal-backup_step-buttons-create',
    },
  },
  completionStep: {
    title: 'cng-contact_deactivation_modal-completion_step-title',
    description: 'cng-contact_deactivation_modal-completion_step-description',
    backupTitle: 'cng-contact_deactivation_modal-completion_step-backup_title',
    backupDescription: 'cng-contact_deactivation_modal-completion_step-backup_description',
    reassignedRoles: 'cng-contact_deactivation_modal-completion_step-reassigned_roles',
    reassignedFlags: 'cng-contact_deactivation_modal-completion_step-reassigned_flags',
    buttons: {
      finish: 'cng-contact_deactivation_modal-completion_step-buttons-finish',
    },
  },
  cancelConfirm: {
    title: 'cng-contact_deactivation_modal-cancel_confirm-title',
    description: 'cng-contact_deactivation_modal-cancel_confirm-description',
    buttons: {
      confirm: 'cng-contact_deactivation_modal-cancel_confirm-buttons-confirm',
      cancel: 'cng-contact_deactivation_modal-cancel_confirm-buttons-cancel',
    },
  },
  skipConfirm: {
    title: 'cng-contact_deactivation_modal-skip_confirm-title',
    description: 'cng-contact_deactivation_modal-skip_confirm-description',
    buttons: {
      confirm: 'cng-contact_deactivation_modal-skip_confirm-buttons-confirm',
      cancel: 'cng-contact_deactivation_modal-skip_confirm-buttons-cancel',
    },
  },
  skipBackupConfirm: {
    title: 'cng-contact_deactivation_modal-skip_backup_confirm-title',
    description: 'cng-contact_deactivation_modal-skip_backup_confirm-description',
    buttons: {
      confirm: 'cng-contact_deactivation_modal-skip_backup_confirm-buttons-confirm',
      cancel: 'cng-contact_deactivation_modal-skip_backup_confirm-buttons-cancel',
    },
  },
}
